import { useTranslation } from 'react-i18next';

import { Timer, VStack, VTextButton, VTooltip } from '@/package';
import { VFlex } from '@/package';
import { new__cn as cn } from '@/package';

const WARNING_TIME = 60 * 15;
const ERROR_TIME = 60 * 5;

type TrackIdSessionTimerProps = {
  /**
   * @description seconds
   */
  remainingTime: number;

  onExtend: () => any;
};

export const TrackIdSessionTimer = ({
  remainingTime,
  onExtend,
}: TrackIdSessionTimerProps) => {
  const { t } = useTranslation();
  const minute = Math.floor(remainingTime / 60);
  const second = remainingTime % 60;

  return (
    <VTooltip
      content={
        <VStack className="bg-black">
          <div>{t('trackIdSession.timerTooltipTitle.scrotum')}</div>
          <ul className="list-inside! list-disc! text-white">
            <li>{t('trackIdSession.timerTooltipDescription0.miasmic')}</li>
            <li>{t('trackIdSession.timerTooltipDescription1.chaffer')}</li>
          </ul>
        </VStack>
      }
      placement="bottom"
    >
      <VFlex
        items="center"
        justify="center"
        className={cn(
          'rounded-full border border-gray-200 py-0.5 pr-1 pl-2',
          getBackgroundColor(remainingTime).backgroundColor,
        )}
        gap={0.25}
      >
        <VFlex className="w-fit text-body-md text-gray-500" items="center">
          <Timer
            className={cn(
              'size-4',
              getBackgroundColor(remainingTime).iconColor,
            )}
          />
          <div className="w-10 text-body-md font-semibold">
            {`${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`}
          </div>
        </VFlex>

        <VTextButton size="xs" onClick={onExtend}>
          {t('trackIdSession.extendTextButton.hypothecative')}
        </VTextButton>
      </VFlex>
    </VTooltip>
  );
};

const getBackgroundColor = (remainingTime: number) => {
  if (remainingTime <= ERROR_TIME) {
    return {
      iconColor: 'text-error-500',
      backgroundColor: 'bg-error-100',
    };
  }
  if (remainingTime <= WARNING_TIME) {
    return {
      iconColor: 'text-warning-500',
      backgroundColor: 'bg-warning-100',
    };
  }
  return {
    iconColor: 'text-gray-500',
    backgroundColor: 'bg-gray-200',
  };
};
